import {
  DESKTOP,
  PHONE,
  TABLET,
  LAPTOP,
  getCurrentDevice,
} from 'helpers/devices';

const DEVICES_TO_STEPS = {
  [DESKTOP]: 9,
  [LAPTOP]: 6,
  [TABLET]: 4,
  [PHONE]: 4,
};

const getIteratorStep = () => DEVICES_TO_STEPS[getCurrentDevice()];

export function* makeTemplatesIterator(templates) {
  const step = getIteratorStep();
  let page = 0;

  while (page * step <= templates.length) {
    const from = page * step;
    const to = from + step <= templates.length ? from + step : templates.length;
    page++;

    yield templates.slice(from, to);
  }
}
